import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import Card from "../Reusable/Card";
import Button from "../Reusable/Button";
import { tw } from "@careinfo/tailwind";
import Form from "./Form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import journalEntrySchema from "../../validation/JournalEntry";
import { useNavigate } from "react-router-dom";
import PopupModal from "../Reusable/Modal";
import CreateAccountPopup from "../Transaction/CreateAccountPopup";
import { getKey } from "../../helpers/sessionKey";

const EditCreditNote = (props: any) => {
  const navigate = useNavigate();
  const [openAccountPopup, setOpenAccountPopup] = useState(false);
  const [openCancelBiLLPopup, setOpenCancelBillPopup] = useState(false);
  const {
    handleEdit,
    isLoading,
    data,
    openPrintPopup,
    setOpenPrintPopup,
    isPrintLoading,
    handlePrint,
    handleRevert,
    isRevertLoading,
    handleCancel,
    handleCreateAccount,
    isPostLoading,
  } = props;
  const {
    handleSubmit,
    setError,
    setValue,
    getValues,
    watch,
    register,
    clearErrors,
    formState: { errors },
    control,
  } = useForm<any>({
    resolver: yupResolver(journalEntrySchema),
    defaultValues: {
      ...data,
      reference_number: {
        id: data?.reference_number,
        name: data?.reference_number,
      },
    },
  });

  const handleClosePrint = () => {
    setOpenPrintPopup(false);
    navigate("/accounting/credit-note");
  };

  const isSuperUser = getKey("is_superuser");
  const adminOnly = data?.is_draft;
  const journalAccounts = watch("journal_account");

  const { fields, append, remove } = useFieldArray({
    control,
    name: "journal_account",
  });

  const handleAddRow = () => {
    append({
      account: "",
      debit: 0,
      credit: 0,
    });
  };

  return (
    <div>
      <Card>
        <form
          onSubmit={handleSubmit((data) => handleEdit(data, false, setError))}
        >
          <Form
            control={control}
            register={register}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            isDraft={data?.is_draft}
            clearErrors={clearErrors}
            setOpenAccountPopup={setOpenAccountPopup}
            watch={watch}
            isEdit={true}
            fields={fields}
            handleAddRow={handleAddRow}
            remove={remove}
          />
          <div className={tw`w-full flex gap-x-4 justify-end px-4`}>
            {/* <div className={tw`w-24 `}>
              <Button
                type="button"
                // disabled={!adminOnly}
                label="Cancel"
                isLoading={isLoading}
                onClick={() => setOpenCancelBillPopup(true)}
              />
            </div> */}
            {data?.is_draft ? (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  disabled={!adminOnly}
                  label="Save to Draft"
                  isLoading={isLoading}
                  onClick={handleSubmit((data) =>
                    handleEdit(data, true, setError)
                  )}
                />
              </div>
            ) : (
              <div className={tw`w-24 `}>
                <Button
                  type="button"
                  // disabled={!adminOnly}
                  label="Revert"
                  isLoading={isRevertLoading}
                  onClick={() => handleRevert(setError)}
                />
              </div>
            )}
            <div className={tw`w-24`}>
              <Button
                label="Submit"
                disabled={!data?.is_draft}
                isLoading={isLoading}
              />
            </div>
          </div>
        </form>
      </Card>
      <PopupModal
        isOpen={openAccountPopup}
        setIsOpen={setOpenAccountPopup}
        title="Create Account"
      >
        <div className={tw`max-w-2xl`}>
          <CreateAccountPopup
            handleCreateAccount={handleCreateAccount}
            isLoading={isPostLoading}
            setOpenAccountPopup={setOpenAccountPopup}
          />
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openCancelBiLLPopup}
        setIsOpen={setOpenCancelBillPopup}
        title="Cancel Bill"
      >
        <div className={tw`p-4 mt-10`}>
          <p className={tw`text-gray-600 mb-6`}>
            Are you sure you want to cancel this bill? This action cannot be
            undone.
          </p>

          <div className={tw`flex justify-center gap-3`}>
            <button
              onClick={() => setOpenCancelBillPopup(false)}
              className={tw`px-6 py-2 rounded-md focus:outline-none bg-gray-200 text-gray-800 hover:bg-gray-300 transition`}
            >
              No
            </button>

            <button
              onClick={() => {
                handleCancel();
                setOpenCancelBillPopup(false);
              }}
              className={tw`px-6 py-2 rounded-md  focus:outline-none bg-red-600 text-white hover:bg-red-700 transition`}
            >
              Yes
            </button>
          </div>
        </div>
      </PopupModal>
      <PopupModal
        isOpen={openPrintPopup}
        setIsOpen={handleClosePrint}
        title={"Print"}
      >
        <form action="#" className={tw`w-[600px]`}>
          <Button
            label={"Print "}
            type="button"
            isLoading={isPrintLoading}
            disabled={isPrintLoading}
            onClick={handlePrint}
            autoFocus
          />
          <Button
            type="button"
            label={"Close"}
            onClick={() => handleClosePrint()}
          />
        </form>
      </PopupModal>
    </div>
  );
};

export default EditCreditNote;
